var map = {
	"./Adriana.txt": 5030,
	"./Alicia.txt": 5609,
	"./Clara.txt": 8085,
	"./Debora.txt": 2115,
	"./Henriette.txt": 7196,
	"./Kirill.txt": 9651,
	"./Michaela.txt": 8936,
	"./Pina.txt": 2594,
	"./Radoslav.txt": 2068,
	"./Tünde.txt": 6443,
	"./balint.txt": 1672,
	"./egle.txt": 5213,
	"./eloise.txt": 5623,
	"./erika.txt": 7150,
	"./zuzana.txt": 2995
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1812;